import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import CustomerModel from './models/CustomerModel';
import AddCustomer from './AddCustomer';
import EditCustomer from './EditCustomer';
import ViewCustomer from './ViewCustomer';
import DeleteCustomer from './DeleteCustomer';

function CustomerModal({onClose, onSubmit, UserAction, show, selectedRow, moduleName}) {
    const [childData, setChildData] = useState(new CustomerModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
                if (show && selectedRow) {
                    setChildData({ ...selectedRow }); // create a new object to break reference
                } else if (!show) {
                    setChildData(new CustomerModel()); // reset when closed
        }
    }, [selectedRow, show]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    if(UserAction === "Add"){
        modalAction = <AddCustomer  isOpen={show} onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = <EditCustomer CustomerData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewCustomer CustomerData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteCustomer CustomerData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                    </div>
    }
  return (
    UserAction !== "Delete" ?
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                dialogClassName="modal-dialog-centered stock-adjust-modal" 
            >
                <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
                    <ModalTitle >{userAction +" "+ moduleName} </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        :   <Modal
                show={show}
                onHide={onClose}
                backdrop="static"            >
           
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div > {userAction} Customer</div>
                    </ModalTitle>
                </ModalHeader>
                
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>  
  )
}

export default CustomerModal